import throttle from '../utils/throttle';

export default class Header {
    constructor() {
        this.header = document.querySelector('.header');
        this.button = this.header.querySelectorAll('.js-open-burger');
        this.button.forEach((el) => {
          el.addEventListener('click', this.toogleBurgerMenu.bind(this))
        })
        this.submenus = this.header.querySelectorAll('.sub-menu')
        this.headerStyles = document.querySelectorAll('[data-header]')
        this.headerHeight = this.header.offsetHeight

        window.addEventListener('scroll', () => {this.onScroll()})
        this.scrollY = false
        this.toggleSubmenus(this.submenus)
        this.animLogo()
        this.headerStyles.forEach((el) => {
          if (el.getBoundingClientRect().top - (this.headerHeight * 2.5) < 0 && el.getBoundingClientRect().bottom - this.headerHeight > 0) {
            this.header.classList.add(el.getAttribute('data-header'))
          }
        })
    }

    toogleBurgerMenu(e) {
        this.header.classList.toggle('open')
        document.querySelector('body').classList.toggle('overflow-hidden')
    }

    toggleSubmenus(submenu) {
        submenu.forEach((sub) => {
            const haveSubmenu = sub.querySelectorAll('[data-subtarget]')
            const isSubmenu = sub.querySelectorAll('[data-sub]')
            haveSubmenu.forEach((el) => {
                // if mobile prevent default on click
                el.addEventListener('click', (e) => {
                    if (window.innerWidth < 1024) {
                      e.preventDefault()
                      el.querySelectorAll('a:not(linkv2)').forEach((item) => {
                        item.addEventListener('click', (e) => {
                          e.stopPropagation()
                        })
                      })
                    }
                })

                //when hover on a submenu put the class active on the submenu and submenu target by the data attribute data-subtarget and remove it from the others
                if (window.innerWidth > 1024) {
                  el.addEventListener('mouseenter', (e) => {
                    this.actionToggle(e, el, haveSubmenu, isSubmenu, false)
                  })
                } else {
                  el.querySelector('.linkv2').classList.remove('active')
                  el.classList.remove('active')
                  const back = el.querySelector('.js-back');
                  if (back) {
                    back.addEventListener('click', (e) => {
                      e.preventDefault()
                      e.stopImmediatePropagation()
                      el.classList.remove('active')
                      el.querySelector('.linkv2').classList.remove('active')
                      const menuContainer = document.querySelector('.header__list');
                      menuContainer.style.height = 'auto';
                      menuContainer.style.overflowY = 'auto';
                      menuContainer.style.overflowX = 'hidden';
                    })
                  }
                  el.addEventListener('click', (e) => {
                    this.actionToggle(e, el, haveSubmenu, isSubmenu, true)
                  })
                }
            })
        })
    }

    actionToggle(e, el, haveSubmenu, isSubmenu, isMobile) {
      e.preventDefault()
      const target = el.getAttribute('data-subtarget')
      haveSubmenu.forEach((el) => {
        if (el.getAttribute('data-subtarget') !== target) {
          el.classList.remove('active')
          el.querySelector('.linkv2').classList.remove('active')
        }
      })
      if (!el.classList.contains('active')) {
        el.classList.add('active')
        el.querySelector('.linkv2').classList.add('active')
        if (isMobile) {
          const listContainer = el.querySelector('.sub-menu__sub-menu--mobile');
          const innerHeight = listContainer.scrollHeight;
          const menuContainer = document.querySelector('.header__list');
          menuContainer.style.height = innerHeight + 137 + 'px';
          menuContainer.style.overflow = 'hidden';
        }
      }
      isSubmenu.forEach((el) => {
        if (el.getAttribute('data-sub') === target) {
          if (!el.classList.contains('active')) {
            el.classList.add('active')
          }
        } else {
          el.classList.remove('active')
        }
      })
    }

    onScroll() {
        // if header enter in the element with data attribute data-header add the class with the value of the data attribute
        let colorStyle = ""
        this.headerStyles.forEach((el) => {
          if (el.getBoundingClientRect().top - (this.headerHeight * 0.5) < 0 && el.getBoundingClientRect().bottom - (this.headerHeight * 0.5) > 0) {
            colorStyle = el.getAttribute('data-header')
            this.header.classList.add(el.getAttribute('data-header'))
          } else {
            if (colorStyle === el.getAttribute('data-header')) {
              return
            }
            this.header.classList.remove(el.getAttribute('data-header'))
          }
        })
        const tolerence = 40
        if (this.header.classList.contains('visible')) {
            if (window.scrollY <= tolerence + 80) {
                this.header.classList.remove('scrolled')
            } else {
                this.header.classList.add('scrolled')
            }
        } else {
              if (window.scrollY <= tolerence) {
                    this.header.classList.remove('scrolled')
              } else {
                    this.header.classList.add('scrolled')
              }
        }
        
        if (this.scrollY <= window.scrollY && this.scrollY !== false) {
            this.header.classList.remove('visible')
        } else {
            this.header.classList.add('visible')
        }
        this.scrollY = window.scrollY
    }

    async animLogo() {
        const parent = document.querySelector('.header__logo-link'),
            animated = parent.getAttribute('data-animated');
        if (!animated) { return }
        import(/* webpackChunkName: "lottie" */ 'lottie-web').then((lottie) => {
            parent.innerHTML = '';
            lottie.loadAnimation({
                container: parent, // the dom element that will contain the animation
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: animated // the path to the animation json
            });
        });
    }
}
